import { TabItem } from '@/components/ui/tab';
import { Sport, StatusItem } from '@/types';

export const imagekit = import.meta.env.VITE_IMAGEKIT_URL;

export const DefineIcons = [
  {
    id: 1,
    title: 'Profile',
    icon: `${imagekit}/downline/profile.svg`,
  },
  // {
  //   id: 2,
  //   title: 'Sport Permission',
  //   icon: `${imagekit}/downline/sportpermission.svg`,
  // },
  {
    id: 3,
    title: 'Deposit',
    icon: `${imagekit}/downline/deposit.svg`,
  },
  {
    id: 4,
    title: 'Withdraw',
    icon: `${imagekit}/downline/withdraw.svg`,
  },
  // {
  //   id: 5,
  //   title: 'Password Change',
  //   icon: `${imagekit}/downline/lock.svg`,
  // },
  {
    id: 6,
    title: 'Change Status',
    icon: `${imagekit}/downline/changestatus.svg`,
  },
  // {
  //   id: 7,
  //   title: 'Bet History',
  //   icon: `${imagekit}/downline/history.svg`,
  // },
];

export const badgeConfig: Record<string, { code: string; bg: string }> = {
  whitelabel: { code: 'WL', bg: 'bg-primary' },
  admin: { code: 'AD', bg: 'bg-green' },
  'sub admin': { code: 'SA', bg: 'bg-dark-blue' },
  'super master': { code: 'SM', bg: 'bg-pink' },
  master: { code: 'MA', bg: 'bg-[#FEB759]' },
  user: { code: 'PL', bg: 'bg-brown' },
  banker: { code: 'BA', bg: 'bg-purple' },
  agent: { code: 'A', bg: 'bg-purple' },
};

export const initialSports: Sport[] = [
  { id: 1, name: 'Cricket', active: true },
  { id: 2, name: 'Soccer', active: true },
  { id: 3, name: 'Tennis', active: true },
  // { id: 4, name: 'Election', active: true },
  // { id: 5, name: 'Kabaddi', active: true },
  // { id: 6, name: 'HR_GR', active: true },
  { id: 4, name: 'Casino', active: true },
];

export const STATUS_OPTIONS: StatusItem[] = [
  { label: 'Active', value: 'Active', color: 'green-500' },
  { label: 'Inactive', value: 'Inactive', color: 'red-500' },
  // { label: 'Suspended', value: 'Suspended', color: 'brown' },
  { label: 'Bet Lock', value: 'BetLock', color: 'black' },
];

export enum UserRole {
  ADMIN = 'ADMIN',
  BANKER = 'BANKER',
  USER = 'USER',
}

export const paymentTabs = [
  {
    id: 'bKash',
    name: 'bKash',
    colorActive: 'bg-[#E2136E] border-[#9E1638] text-white',
    colorInActive: 'bg-white border-[#9E1638] text-[#E2136E]',
    icon: '/bKash.svg',
  },
  {
    id: 'Nagad',
    name: 'Nagad',
    colorActive: 'bg-[#EA1C2D] border-[#EA1C2D] text-white',
    colorInActive: 'bg-white border-[#EA1C2D] text-[#EA1C2D]',
    icon: '/nagad.svg',
  },
  {
    id: 'Rocket',
    name: 'Rocket',
    colorActive: 'bg-[#6C0074] border-[#6C0074] text-white',
    colorInActive: 'bg-white border-[#6C0074] text-[#6C0074]',
    icon: '/rocket.svg',
  },
];

export const tabList: TabItem[] = [
  { id: 'qr', label: 'Manage QR' },
  { id: 'account', label: 'Manage Account' },
];

export const accountTabList: TabItem[] = [
  { id: 'all', label: 'All' },
  { id: 'upi', label: 'UPI' },
  { id: 'bank', label: 'Bank Account' },
];

export const dwTabs: TabItem[] = [
  { id: 'Credit', label: 'Deposit' },
  { id: 'Debit', label: 'Withdraw' },
];

export const bankerDetailTab: TabItem[] = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'd-w-request', label: 'Deposit/Withdraw Requests' },
  { id: 'account-statement', label: 'Account Statement' },
];

export const eventManageTab: TabItem[] = [
  { id: 'import', label: 'InActive Matches' },
  { id: 'inplay', label: 'InPlay' },
  { id: 'upcoming', label: 'Upcoming' },
];

export const statusColor = {
  active: 'text-green-500 border border-green-500',
  inactive: 'text-red-500 border border-red-500',
  bet_lock: 'text-gray-600 border border-gray-400',
  suspended: 'text-brown border border-brown',
} as const;

export const dotColor = {
  active: 'bg-green-500',
  inactive: 'bg-red-500',
  bet_lock: 'bg-yellow-500',
  suspended: 'bg-gray-500',
} as const;

export const CasinoTabs: TabItem[] = [
  { id: 'category', label: 'Category Level' },
  { id: 'provider', label: 'Provider Level' },
  { id: 'game', label: 'Game Control' },
];

export const BetListTab: TabItem[] = [
  { id: 'Hierarchy', label: 'Agent Players' },
  { id: 'Direct', label: 'Platform Player' },
];

export const userListTab: TabItem[] = [
  { id: 'Platform', label: 'Owners Users' },
  { id: 'Direct', label: 'Platform Users' },
];

export const InactiveMemberTab: TabItem[] = [
  { id: 'Hierarchy', label: 'Hierarchy' },
  { id: 'Direct', label: 'Platform Users' },
];

export const contentManagementTabs = [
  {
    id: 1,
    label: 'Banner Management',
    img: `${imagekit}/contentManagement/banner.svg`,
  },
  {
    id: 2,
    label: 'Notification Management',
    img: `${imagekit}/contentManagement/notification.svg`,
  },
  {
    id: 3,
    label: 'Support Contact Management',
    img: `${imagekit}/contentManagement/support.svg`,
  },
];

export const managementTabs: TabItem[] = [
  {
    id: 'Banner',
    label: 'Banner Management',
    img: '/images/contentManagement/banner.svg',
  },
  {
    id: 'Notification',
    label: 'Notification Management',
    img: '/images/contentManagement/notification.svg',
  },
  {
    id: 'Contact',
    label: 'Support Contact Management',
    img: '/images/contentManagement/support.svg',
  },
];

export const Sports: TabItem[] = [
  { label: 'All', id: 'All' },
  { label: 'Cricket', id: 'Cricket' },
  { label: 'Football', id: 'Soccer' },
  { label: 'Tennis', id: 'Tennis' },
  { label: 'HorseRacing', id: 'HorseRacing' },
];

export const EventTabs: TabItem[] = [
  { label: 'Sports', id: 'Sports' },
  { label: 'Casino', id: 'Casino' },
];

export const SportsTabs: TabItem[] = [
  { label: 'Cricket', id: 'Cricket' },
  { label: 'Football', id: 'Soccer' },
  { label: 'Tennis', id: 'Tennis' },
];

export const BussinessReportTabs: TabItem[] = [
  { label: 'First Deposit', id: 'FIRST' },
  { label: 'Refill Deposit', id: 'REFILL' },
];
export const STATUS_LOGOUT_MESSAGES: Record<string, string> = {
  inactive: 'Your account has been deactivated. You have been logged out.',
  suspended: 'Your account has been suspended. You have been logged out.',
  bet_lock: 'Betting has been locked on your account. You have been logged out.',
};

export const SubUserTabs: TabItem[] = [
  { label: 'Master', id: 'UpperHierarchy' },
  { label: 'Users', id: 'User' },
];

export const AccountStatementTabs: TabItem[] = [
  { label: 'Deposit/Withdraw', id: 'Deposit/Withdraw' },
  { label: 'Game Transaction', id: 'Game Transaction' },
];

export const ROLES = {
  OWNER: 'OWNER',
  AGENT: 'AGENT',
  USER: 'USER',
} as const;

export const ROLE_GROUPS = {
  CAN_ACCESS_DW_REQUEST: [ROLES.OWNER],
} as const;

// ✅ Updated to handle undefined/null
export const hasRole = (
  userRole: string | undefined | null,
  allowedRoles: readonly string[]
): boolean => {
  if (!userRole) return false;
  return allowedRoles.includes(userRole);
};

export const isOwner = (role: string | undefined | null) => role === ROLES.OWNER;
export const isAgent = (role: string | undefined | null) => role === ROLES.AGENT;
